// export default ProductMap = {
exports.ProductMap = {
  7: {
    '2 kWh': [{
      name: 'Get Set Kit (2kWh)',
      pid: '7686916538615',
      varId: '42952013349111',
      adaptBatCap: 2,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '3898',
      old_price: '4898',
      save_money: '1000',
      imgSrc: '/img/mm100/preview/setkit-2kw.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '1x 2 kWh LFP-Batterie', '1x Kabelpaket'],
      detailImgList: ['power-2kw.jpg', 'wire.jpg'],
      desc: 'Mit dem Get Set Kit können Sie mit einem LFP-Batterien und einem Power Hub schnell ein System zur elektrischen Grundversorgung für Ihr Wohmobil/netzunabhängiges Heim aufbauen.'
    }, {
      name: 'Prepared Kit (2kWh)',
      pid: '7686916538615',
      varId: '42952013381879',
      adaptBatCap: '2-1',
      limit: 2,
      consoleChoose: 'Y',
      off_price: '4398',
      old_price: '5468',
      save_money: '1070',
      imgSrc: '/img/mm100/preview/prekit-2kw.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '1x 2 kWh LFP-Batterie', '1x Kabelpaket', '1x Intelligenten AC/DC-Verteilerkasten', '1x Batterie-Montagegurt'],
      detailImgList: ['bundle-2kw-dp.jpg', 'wire.jpg'],
      desc: 'Das Prepared Kit bietet Ihnen mehr Kontrolle über Ihren Stromverbrauch sowie Komfort beim Reisen oder Wohnen an netzfernen Orten.'
    }, {
      name: 'Independence Kit (2kWh)',
      pid: '7686916538615',
      varId: '42952013414647',
      adaptBatCap: '2-1',
      limit: 2,
      off_price: '4698',
      old_price: '5798',
      save_money: '1100',
      imgSrc: '/img/mm100/preview/indkit-2kw-us.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '1x 2 kWh LFP-Batterie', '1x Kabelpaket', '1x Intelligenten AC/DC-Verteilerkasten', '1x Power Kit Konsole', '2x Batterie-Montagegurt'],
      detailImgList: ['bundle-2kw-all_us.jpg', 'wire.jpg'],
      desc: 'Das Independence Kit liefert eine vollständig netzunabhängige Stromlösung. Mit dem intelligenten AC/DC-Verteilerkasten und der Power Kit Konsole von EcoFlow können Sie Ihre Stromversorgung über die Wandkonsole oder die mobile App überwachen, steuern und anpassen.'
    }],
    '4 kWh': [{
      name: 'Get Set Kit (4kWh)',
      pid: '7686916571383',
      varId: '42952013447415',
      adaptBatCap: 2,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '5597',
      old_price: '7097',
      save_money: '1500',
      imgSrc: '/img/mm100/preview/setkit-4kw.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '2x 2 kWh LFP - Batterie', '1x Kabelpaket'],
      detailImgList: ['power-4kw.jpg', 'wire.jpg'],
      desc: 'Mit dem Get Set Kit können Sie mit einem LFP-Batterien und einem Power Hub schnell ein System zur elektrischen Grundversorgung für Ihr Wohmobil/netzunabhängiges Heim aufbauen.'
    }, {
      name: 'Prepared Kit (4kWh)',
      pid: '7686916571383',
      varId: '42952013480183',
      adaptBatCap: '2-1',
      limit: 1,
      consoleChoose: 'Y',
      off_price: '6097',
      old_price: '7667',
      save_money: '1570',
      imgSrc: '/img/mm100/preview/prekit-4kw.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '2x 2 kWh LFP-Batterie', '1x Kabelpaket', '1x Intelligenten AC/DC-Verteilerkasten', '2x Batterie-Montagegurt'],
      detailImgList: ['bundle-4kw-dp.jpg', 'wire.jpg'],
      desc: 'Das Prepared Kit bietet Ihnen mehr Kontrolle über Ihren Stromverbrauch sowie Komfort beim Reisen oder Wohnen an netzfernen Orten.'
    }, {
      name: 'Independence Kit (4kWh)',
      pid: '7686916571383',
      varId: '42952013512951',
      adaptBatCap: '2-1',
      limit: 1,
      off_price: '6397',
      old_price: '7997',
      save_money: '1600',
      imgSrc: '/img/mm100/preview/indkit-4kw-us.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '2x 2 kWh LFP-Batterie', '1x Kabelpaket', '1x Intelligenten AC/DC-Verteilerkasten', '1x Power Kit Konsole', '2x Batterie-Montagegurt'],
      detailImgList: ['bundle-4kw-all_us.jpg', 'wire.jpg'],
      desc: 'Das Independence Kit liefert eine vollständig netzunabhängige Stromlösung. Mit dem intelligenten AC/DC-Verteilerkasten und der Power Kit Konsole von EcoFlow können Sie Ihre Stromversorgung über die Wandkonsole oder die mobile App überwachen, steuern und anpassen.'
    }],
    '5 kWh': [{
      name: 'Get Set Kit (5kWh)',
      pid: '7686916604151',
      varId: '42952013545719',
      adaptBatCap: 5,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '5998',
      old_price: '7498',
      save_money: '1500',
      imgSrc: '/img/mm100/preview/setkit-5kw.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '1x 5 kWh LFP-Batterie', '1x Kabelpaket'],
      detailImgList: ['power-5kw.jpg', 'wire.jpg'],
      desc: 'Mit dem Get Set Kit können Sie mit einem LFP-Batterien und einem Power Hub schnell ein System zur elektrischen Grundversorgung für Ihr Wohmobil/netzunabhängiges Heim aufbauen.'
    }, {
      name: 'Prepared Kit (5kWh)',
      pid: '7686916604151',
      varId: '42952013578487',
      adaptBatCap: '5-1',
      limit: 2,
      consoleChoose: 'Y',
      off_price: '6498',
      old_price: '8068',
      save_money: '1570',
      imgSrc: '/img/mm100/preview/prekit-5kw.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '1x 5 kWh LFP-Batterie', '1x Kabelpaket', '1x Intelligenten AC/DC-Verteilerkasten', '1x Batterie-Montagegurt'],
      detailImgList: ['bundle-5kw-dp.jpg', 'wire.jpg'],
      desc: 'Das Prepared Kit bietet Ihnen mehr Kontrolle über Ihren Stromverbrauch sowie Komfort beim Reisen oder Wohnen an netzfernen Orten.'
    }, {
      name: 'Independence Kit (5kWh)',
      pid: '7686916604151',
      varId: '42952013611255',
      adaptBatCap: '5-1',
      limit: 2,
      off_price: '6798',
      old_price: '8398',
      save_money: '1600',
      imgSrc: '/img/mm100/preview/indkit-5kw-us.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '1x 5 kWh LFP-Batterie', '1x Kabelpaket', '1x Intelligenten AC/DC-Verteilerkasten', '1x Power Kit Konsole', '1x Batterie-Montagegurt'],
      detailImgList: ['bundle-5kw-all_us.jpg', 'wire.jpg'],
      desc: 'Das Independence Kit liefert eine vollständig netzunabhängige Stromlösung. Mit dem intelligenten AC/DC-Verteilerkasten und der Power Kit Konsole von EcoFlow können Sie Ihre Stromversorgung über die Wandkonsole oder die mobile App überwachen, steuern und anpassen.'
    }],
    '10 kWh': [{
      name: 'Get Set Kit (10kWh)',
      pid: '7686916669687',
      varId: '42952013644023',
      adaptBatCap: 5,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '9797',
      old_price: '12297',
      save_money: '2500',
      imgSrc: '/img/mm100/preview/setkit-10kw.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '2x 5 kWh LFP-Batterie', '1x Kabelpaket'],
      detailImgList: ['power-10kw.jpg', 'wire.jpg'],
      desc: 'Mit dem Get Set Kit können Sie mit einem LFP-Batterien und einem Power Hub schnell ein System zur elektrischen Grundversorgung für Ihr Wohmobil/netzunabhängiges Heim aufbauen.'
    }, {
      name: 'Prepared Kit (10kWh)',
      pid: '7686916669687',
      varId: '42952013676791',
      adaptBatCap: '5-1',
      limit: 1,
      consoleChoose: 'Y',
      off_price: '10297',
      old_price: '12867',
      save_money: '2570',
      imgSrc: '/img/mm100/preview/prekit-10kw.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '2x 5 kWh LFP-Batterie', '1x Kabelpaket', '1x Intelligenten AC/DC-Verteilerkasten', '2x Batterie-Montagegurt'],
      detailImgList: ['bundle-10kw-dp.jpg', 'wire.jpg'],
      desc: 'Das Prepared Kit bietet Ihnen mehr Kontrolle über Ihren Stromverbrauch sowie Komfort beim Reisen oder Wohnen an netzfernen Orten.'
    }, {
      name: 'Independence Kit (10kWh)',
      pid: '7686916669687',
      varId: '42952013709559',
      adaptBatCap: '5-1',
      limit: 1,
      off_price: '10597',
      old_price: '13197',
      save_money: '2600',
      imgSrc: '/img/mm100/preview/indkit-10kw-us.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '2x 5 kWh LFP-Batterie', '1x Kabelpaket', '1x Intelligenten AC/DC-Verteilerkasten', '1x Power Kit Konsole', '2x Batterie-Montagegurt'],
      detailImgList: ['bundle-10kw-all_us.jpg', 'wire.jpg'],
      desc: 'Das Independence Kit liefert eine vollständig netzunabhängige Stromlösung. Mit dem intelligenten AC/DC-Verteilerkasten und der Power Kit Konsole von EcoFlow können Sie Ihre Stromversorgung über die Wandkonsole oder die mobile App überwachen, steuern und anpassen.'
    }],
    '15 kWh': [{
      name: 'Get Set Kit (15kWh)',
      pid: '7686916735223',
      varId: '42952014594295',
      consoleChoose: 'Y',
      off_price: '13596',
      old_price: '17096',
      save_money: '3500',
      imgSrc: '/img/mm100/preview/setkit-15kw.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '3x 5 kWh LFP-Batterie', '1x Kabelpaket'],
      detailImgList: ['power-15kw.jpg', 'wire.jpg'],
      desc: 'Mit dem Get Set Kit können Sie mit einem LFP-Batterien und einem Power Hub schnell ein System zur elektrischen Grundversorgung für Ihr Wohmobil/netzunabhängiges Heim aufbauen.'
    }, {
      name: 'Prepared Kit (15kWh)',
      pid: '7686916735223',
      varId: '42952014627063',
      consoleChoose: 'Y',
      off_price: '14096',
      old_price: '17666',
      save_money: '3570',
      imgSrc: '/img/mm100/preview/prekit-15kw.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '3x 5 kWh LFP-Batterie', '1x Kabelpaket', '1x Intelligenten AC/DC-Verteilerkasten', '3x Batterie-Montagegurt'],
      detailImgList: ['bundle-15kw-dp.jpg', 'wire.jpg'],
      desc: 'Das Prepared Kit bietet Ihnen mehr Kontrolle über Ihren Stromverbrauch sowie Komfort beim Reisen oder Wohnen an netzfernen Orten.'
    }, {
      name: 'Independence Kit (15kWh)',
      pid: '7686916735223',
      varId: '42952014659831',
      off_price: '14396',
      old_price: '17996',
      save_money: '3600',
      imgSrc: '/img/mm100/preview/indkit-15kw-us.jpg',
      delivery_date: 'Mitte August 2022',
      accessories: ['1x Power Hub', '3x 5 kWh LFP-Batterie', '1x Kabelpaket', '1x Intelligenten AC/DC-Verteilerkasten', '1x Power Kit Konsole', '3x Batterie-Montagegurt'],
      detailImgList: ['bundle-15kw-all_us.jpg', 'wire.jpg'],
      desc: 'Das Independence Kit liefert eine vollständig netzunabhängige Stromlösung. Mit dem intelligenten AC/DC-Verteilerkasten und der Power Kit Konsole von EcoFlow können Sie Ihre Stromversorgung über die Wandkonsole oder die mobile App überwachen, steuern und anpassen.'
    }]
  }
};
exports.solarPanelMap = {
  7: [{
    name: '2*100W Starres Solarpanel+2*Montagefüße',
    pid: '7686916833527',
    varId: '42952014758135',
    old_price: '192.44',
    off_price: '150.42',
    save_money: '42.02',
    limit: 99,
    // discount: "%1=369%%2=729%%3=1089%%n={per=1,off=0}%",
    imgSrc: '/img/mm100/preview/rigid-100w.jpg'
  }, {
    name: '2*400W Starres Solarpanel+4*Montagefüße',
    pid: '7686916866295',
    varId: '42952014790903',
    old_price: '671.43',
    off_price: '503.36',
    save_money: '168.07',
    limit: 99,
    // tips: "*Dieser Artikel ist von der kostenlosen Lieferung ausgeschlossen.",
    imgSrc: '/img/mm100/preview/rigid-400w.jpg'
  }, {
    name: '1*100W Flexibles Solarpanel',
    pid: '7686916931831',
    varId: '42952014823671',
    old_price: '149',
    off_price: '129',
    save_money: '20',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-100w.jpg'
  }]
};
exports.BatteryMap = {
  7: [{
    name: '2 kWh LFP-Batterie + Montagegurt + Batteriekabel',
    pid: '7686916767991',
    varId: '42977163837687',
    off_price: '1748',
    old_price: '2248',
    save_money: '500',
    capacity: '2-1',
    imgSrc: '/img/mm100/preview/battery-2kw.jpg'
  }, {
    name: '5 kWh LFP-Batterie + Montagegurt + Batteriekabel',
    pid: '7686916767991',
    varId: '42977165017335',
    off_price: '3848',
    old_price: '4848',
    save_money: '1000',
    capacity: '5-1',
    imgSrc: '/img/mm100/preview/battery-5kw.jpg'
  }
  // {
  //     name: '2 kWh LFP-Batterie',
  //     pid: '7686916767991',
  //     varId: '42952014692599',
  //     off_price: '1699',
  //     old_price: '2199',
  //     save_money: '500',
  //     capacity: 2,
  //     imgSrc: '/img/mm100/preview/battery-2kw.jpg',
  // },
  // {
  //     name: '5 kWh LFP-Batterie',
  //     pid: '6761212510281',
  //     varId: '42952014725367',
  //     off_price: '3799',
  //     old_price: '4799',
  //     save_money: '1000',
  //     capacity: 5,
  //     imgSrc: '/img/mm100/preview/battery-5kw.jpg',
  // },
  // {
  //     name: '2 kWh LFP-Batterie + Montagegurt',
  //     pid: '7686916767991',
  //     varId: '42977163837687',
  //     off_price: '1748',
  //     old_price: '2248',
  //     save_money: '500',
  //     capacity: '2-1',
  //     imgSrc: '/img/mm100/preview/battery-2kw.jpg',
  // },
  // {
  //     name: '5 kWh LFP-Batterie + Montagegurt',
  //     pid: '7686916767991',
  //     varId: '42977165017335',
  //     off_price: '3848',
  //     old_price: '4848',
  //     save_money: '1000',
  //     capacity: '5-1',
  //     imgSrc: '/img/mm100/preview/battery-5kw.jpg',
  // },
  ]
};

// exports.InstallationMap = {
//     7: {
//         pid: '7686916964599',
//         varId: '42952014856439',
//         off_price: '0',
//         old_price: '0',
//         save_money: '0',
//     },
// };

exports.ConsoleMap = {
  7: [{
    name: 'EcoFlow Power Kits Console',
    pid: '7707423473911',
    varId: '43016207270135',
    off_price: '349',
    old_price: '349',
    limit: 1,
    // save_money: '599',
    prdType: 'console',
    imgSrc: '/img/calculators/mm100/combo-console.jpg'
  }]
};
exports.ShopifyUrl = 'https://de.ecoflow.com/';